import type { PartnerBookingSlotPayload } from './partnerBookingsCheckout';

export const PARTNER_BOOKINGS_QUOTE_API = 'v1/partner-bookings/quote';

/** Same inputs as checkout; nothing is held or booked. */
export type PostRequestPayload = PartnerBookingSlotPayload;

export interface PostResponsePayload {
  currency: string;
  /** The court rental the player sees, priced on the server. */
  subtotalUnitAmount: number;
  /** Taxes and card fees; zero until a fee policy exists. */
  feeUnitAmount: number;
  totalUnitAmount: number;
}
